const theme = {
    alerts: {
        errorColor: '#FDEDED',
        errorIconColor: 'red'
    }
}

export default theme;